import React from 'react'
import { useNavigate } from 'react-router-dom'
import WidgetCard from './WidgetCard'
import { GhostButton } from '../../../layout/styledComponents'

export default function CrisisBannerCard({ data }) {
  const navigate = useNavigate()
  if (!data || !data.message) return null
  return (
    <WidgetCard tone="urgent" title="If you need help right now">
      <p style={{ margin: 0, marginBottom: 14, lineHeight: 1.5 }}>{data.message}</p>
      <GhostButton onClick={() => navigate(data.contactPath || '/patient-home/help/crisis')}>
        Get help now
      </GhostButton>
    </WidgetCard>
  )
}
